const VideosTypes = {
  SET_VIDEOS_LOADING: 'SET_VIDEOS_LOADING',
  SET_VIDEOS_FAILURE: 'SET_VIDEOS_FAILURE',
  SET_VIDEOS_SUCCESS: 'SET_VIDEOS_SUCCESS',
};

export default VideosTypes;